import { DISPLAY_LANGUAGE_LIST } from '../../utils/constants/utilConstants';

/**
 * Removes the last element of the url ie id
 * Used for Ladies and gentleman episode
 * /tv-shows/details/alpha/123/beta/456 => /tv-shows/details/alpha/123/beta
 */
export const getUrlSplit = (url: string) => {
  let urlSplit;
  urlSplit = url && url.split('/');
  if (urlSplit && urlSplit.length) {
    urlSplit.pop();
    urlSplit = urlSplit.join('/');
  }
  return urlSplit;
};

/**
 * removes global and display langauage from the url
 */
export const filterPathname = (pathName: string) => {
  const pathNameFiltered = pathName.split('/global');
  let newPathNameFiltered =
    pathNameFiltered.length === 1 ? pathNameFiltered[0] : pathNameFiltered[1];
  const isDisplayLang = DISPLAY_LANGUAGE_LIST.filter((lang) =>
    newPathNameFiltered.startsWith(`/${lang}`)
  );
  newPathNameFiltered =
    isDisplayLang.length > 0
      ? newPathNameFiltered.slice(3)
      : newPathNameFiltered;
  return newPathNameFiltered;
};
